import { Card, CardContent, CardHeader, CardTitle } from "@/shared/ui/card";
import { TrendingUp, TrendingDown, Activity } from "lucide-react";

interface KPIData {
  title: string;
  value: string;
  change: number;
  target?: string;
  status: "up" | "down" | "neutral";
}

export function ProductionKPIWidget() {
  const kpis: KPIData[] = [
    { title: "OEE", value: "84.5%", change: 2.3, target: "85%", status: "up" },
    { title: "Availability", value: "92.1%", change: -1.2, target: "95%", status: "down" },
    { title: "Performance", value: "89.3%", change: 1.8, status: "up" },
    { title: "Quality Rate", value: "97.2%", change: 0.5, target: "98%", status: "up" },
  ];

  return (
    <Card className="h-full">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <Activity className="h-4 w-4" />
          Production KPIs
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          {kpis.map((kpi, index) => (
            <div key={index} className="space-y-1">
              <p className="text-xs text-muted-foreground">{kpi.title}</p>
              <div className="flex items-baseline gap-2">
                <span className="text-2xl font-bold">{kpi.value}</span>
                {kpi.status === "up" && (
                  <span className="text-xs text-success flex items-center">
                    <TrendingUp className="h-3 w-3 mr-0.5" />
                    +{kpi.change}%
                  </span>
                )}
                {kpi.status === "down" && (
                  <span className="text-xs text-destructive flex items-center">
                    <TrendingDown className="h-3 w-3 mr-0.5" />
                    {kpi.change}%
                  </span>
                )}
              </div>
              {kpi.target && (
                <p className="text-xs text-muted-foreground">Target: {kpi.target}</p>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
